"use client"

import { MenuIcon } from "@/components/icons/pixel-icons"
import { HUD_ICON_BUTTON_CLASS } from "./hud-button-style"

interface HamburgerMenuButtonProps {
  onClick: () => void
}

export const HamburgerMenuButton = ({ onClick }: HamburgerMenuButtonProps) => {
  return (
    <button
      id="codex-menu-button"
      onClick={onClick}
      className={HUD_ICON_BUTTON_CLASS}
      title="Open Codex"
      aria-label="Open codex menu"
    >
      <MenuIcon size={20} />
    </button>
  )
}
